<template>
    <wrapper>
        <template slot="wrapper">
            <div class="o-shell">
                <app-header/>

                <main class="o-main">
                    <post>
                        <template slot="header">
                            <h1>How Much Money Will You Really Spend In Retirement? A Lot More Than You Think.</h1>

                            <h5>By Dan Ariely and Aline Holzwarth</h5>
                        </template>

                        <template slot="content">
                            <p>
                                It’s the question that plagues pretty much everybody as they
                                look ahead: How much money will I need in retirement? Most
                                likely, a lot more than you think. Let us explain. The typical
                                approach most people take is to ask what percentage of their
                                final salary they think they will need in retirement. If you have
                                ever visited a financial adviser, you must have been asked
                                this sort of question.
                                <a target="_blank"
                                    href="http://www.wsj.com/articles/how-much-money-will-you-really-spend-in-retirement-probably-a-lot-more-than-you-think-1536026820"
                                >Related article</a>
                            </p>

                            <router-link to="/intro" class="c-button">Get started</router-link>
                        </template>

                        <template slot="img">
                            <img src="~assets/Artwork@2x.png">
                        </template>
                    </post>
                </main>
            </div>
        </template>
    </wrapper>
</template>

<script>
    import Header from "components/header/header.vue";
    import Article from "components/article/Article.vue";
    import Button from "components/button/button.vue";
    import Wrapper from "components/wrapper/Wrapper.vue";

    export default {
        components: {
            "app-header": Header,
            post: Article,
            btn: Button,
            wrapper: Wrapper
        }
    };
</script>
